const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/published/v1/swimlane/$linkId/png/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { publishedSwimlaneSearchSchema } from '../searchSchema';

/**
 * PNG export template route for single-view tiled screenshot approach.
 * Renders the full published swimlane with isPngPublicationTemplate={true}
 * which enables the data-publicationid attribute for Playwright to capture.
 *
 * Query parameters are defined in the shared publishedSwimlaneSearchSchema.
 */
export const Route = createFileRoute('/(unauthenticated)/published/v1/swimlane/$linkId/png')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(publishedSwimlaneSearchSchema)
});